import React from 'react';
import PDF from "../../assets/images/lunchMenu.png"
const PdfViewerLunch = () => {
  return (
    <div>
      <img src={PDF} className='h-auto' alt='lunch menu' />
    </div>
  );
};

export default PdfViewerLunch;
